export default __webpack_public_path__ + "static/media/ic_contact_b.54ae62a9.svg";